import { Analytics } from '@cobliteam/analytics';
import { PerformanceReports } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import Alert from '@cobliteam/ui/components/Alert';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { downloadIncidentsReportEnd, downloadRoutesPointsReportEnd } from './actionCreators';
import type * as Action from './actions';
import { ReportsActionTypes } from './reportsActionTypes';

const env = Environment.getInstance().getEnvironment();
const reportsRequester = new PerformanceReports({ host: env.herbieApiHost });

const downloadReportFile = (blob: Blob, name: string, startInMilli: number, endInMilli: number, format = 'xls'): void => {
  const startTimeStr = moment(startInMilli).format('YYMMDD');
  const endTimeStr = moment(endInMilli).format('YYMMDD');
  const periodStr = startTimeStr === endTimeStr ? startTimeStr : `${startTimeStr}_${endTimeStr}`;
  const filename = `Cobli_${periodStr}_${name}.${format}`;
  saveAs(blob, filename);
};

export function* requestDownloadIncidentsReportSaga(action: Action.DownloadIncidentsReportRequest) {
  const { start, end } = action.payload;

  try {
    const reportBlob: Blob = yield call(reportsRequester.getIncidentsReport, start, end);
    downloadReportFile(reportBlob, 'alertas', start, end);
  } catch (err) {
    Alert.error('Ops! O sistema apresentou um erro e não foi possível exportar o relatório, tente novamente.');
  } finally {
    yield put(downloadIncidentsReportEnd());
  }
}

export function* requestDownloadRoutesPointsReportSaga(action: Action.DownloadRoutesPointsReportRequest) {
  const { period, vehicleId, sampleInMinutes } = action.payload;
  const daysCount = moment(period.end).diff(moment(period.start), 'days');

  try {
    Analytics.track('Points Report Requested', { days: daysCount });
    const reportBlob: Blob = yield call(reportsRequester.getRoutesPointsReport, period, vehicleId, sampleInMinutes);
    downloadReportFile(reportBlob, 'pontostrajetos', period.start, period.end);
    Analytics.track('Points Report Exported', { days: daysCount });
  } catch (err) {
    Analytics.track('Points Report Error', { days: daysCount });
    Alert.error('Ops! O sistema apresentou um erro e não foi possível exportar o relatório, tente novamente.');
  } finally {
    yield put(downloadRoutesPointsReportEnd());
  }
}

export function* ReportsSagasListener() {
  yield all([
    takeLatest(ReportsActionTypes.DOWNLOAD_INCIDENTS_REPORT_REQUEST, requestDownloadIncidentsReportSaga),
    takeLatest(ReportsActionTypes.DOWNLOAD_ROUTES_POINTS_REPORT_REQUEST, requestDownloadRoutesPointsReportSaga),
  ]);
}
